import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TableInvitadosExistentes from "../DataTables/Existentes/TableInvitadosExistentes";

const TabConsulta = () => {
  return (
    <Container fluid>
      <Row className="mt-3">
        <Col>
          <TableInvitadosExistentes />
        </Col>
      </Row>
    </Container>
  );
};

export default TabConsulta;
